import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { getMatchedRequests } from "../../api/ads.api.js";
import "./AdMatchedRequestsTable.scss";

const AdMatchedRequestsTable = ({
  requestsToSend,
  setRequestsToSend,
  searchValue,
  canSearch,
  setCanSearch,
}) => {
  const { id } = useParams();

  const [requests, setRequests] = useState([]);

  useEffect(() => {
    getMatchedRequests(id, "").then((res) => setRequests(res));
  }, [id]);
  useEffect(() => {
    if (canSearch) {
      getMatchedRequests(id, searchValue).then((res) => setRequests(res));
      setCanSearch(false);
    }
  }, [canSearch, searchValue, id]);

  // Add this helper function inside your component
  const isSelectable = (data) => {
    return !data?.requestContact?.notReceiveCommunications;
  };

  return (
    <div>
      <DataTable
        value={requests.length !== 0 ? requests : ""}
        paginator
        rows={10}
        removableSort
        responsiveLayout="scroll"
        resizableColumns
        dataKey="_id"
        selectionMode="checkbox"
        selection={requestsToSend}
        onSelectionChange={(ev) => setRequestsToSend(ev.value)} // Logic is now handled by the table
        isDataSelectable={(ev) => isSelectable(ev.data)} // <--- KEY ADDITION
        rowClassName={(data) => (!isSelectable(data) ? "row-disabled" : "")} // Optional: visual hint
        columnResizeMode="fit"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        rowsPerPageOptions={[10, 25, 50]}
      >
        <Column selectionMode="multiple" headerStyle={{ width: "1%" }}></Column>
        <Column
          field="requestReference"
          header="Id Petición"
          body={(ev) => (
            <Link to={`/peticiones/${ev._id}`}>{ev.requestReference}</Link>
          )}
          sortable
          style={{ width: "5%" }}
        ></Column>
        <Column
          header="Nombre Completo"
          sortable
          field="requestContact.fullName"
          style={{ width: "12%" }}
          body={(rowData) =>
            rowData.requestContact?.fullName || (
              <span className="text-muted italic">Sin información</span>
            )
          }
        ></Column>
        <Column
          header="Empresa"
          sortable
          field="requestContact.company"
          style={{ width: "12%" }}
          body={(rowData) =>
            rowData.requestContact?.company || (
              <span className="text-muted">-</span>
            )
          }
        ></Column>
        <Column
          header="Email"
          sortable
          field="requestContact.email"
          style={{ width: "10%" }}
          body={(rowData) =>
            rowData.requestContact?.email || (
              <span className="text-muted">-</span>
            )
          }
        ></Column>
        <Column
          field="requestComment"
          header="Comentarios"
          style={{ width: "50%" }}
        ></Column>
      </DataTable>
    </div>
  );
};

export default AdMatchedRequestsTable;
